import { equals } from "effect/Equal";
import { atom } from "jotai";
import { atomFamily, selectAtom } from "jotai/utils";
import { getDevNameStatesAtom } from "./devNameStatesMapAtom.ts";

const getFavoriteKeysAtom = atomFamily((devStateName: string) =>
  selectAtom(
    getDevNameStatesAtom(devStateName),
    (map) => [...map.entries()].map((a) => a[1]?.favorite && a[0]).filter((a): a is string => Boolean(a)),
    equals,
  ),
);

export const getFavoriteKeysOrderAtom = atomFamily((devStateName: string) => {
  const favoriteKeysAtom = getFavoriteKeysAtom(devStateName);
  return atom((get) => {
    const favoriteKeys = new Set(get(favoriteKeysAtom));
    let preferredKeys: null | string[] = null;
    let preferredKeysLenPlusOneNegative = 0;
    const compare = (a: string, b: string) => {
      let ord = (favoriteKeys.has(b) ? 1 : 0) - (favoriteKeys.has(a) ? 1 : 0);
      if (ord === 0 && preferredKeys)
        // put preferred first and ordered by where they are in the preferred keys
        ord =
          (~preferredKeys.indexOf(b) || preferredKeysLenPlusOneNegative) -
          (~preferredKeys.indexOf(a) || preferredKeysLenPlusOneNegative);
      if (ord === 0) return a.localeCompare(b);
      return ord;
    };
    return (obj: object, keyOrderPreference?: string[]) => {
      const keys = Object.keys(obj);
      preferredKeys = keyOrderPreference ?? null;
      preferredKeysLenPlusOneNegative = -((preferredKeys?.length ?? 0) + 1);
      return keys.sort(compare);
    };
  });
});
